import { Row as CoreRow } from '@lib/core/src/styledComponents/StyledComponents';
import palette from '@lib/core/src/theme/palette';
import { IconButton, Stack, styled, Typography, Theme } from '@mui/material';

import { DRAWER_WIDTH_LARGE } from '@/components/Meeting/MeetingStyles';

export const Container = styled(Stack)<{ theme?: Theme }>(({ theme }) => ({
  gap: '20px',
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH_LARGE} + 2vw)`,
    paddingRight: '2vw'
  }
}));

export const DrawerOpenButton = styled(Stack)({
  cursor: 'pointer',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
  padding: '0 12px',
  position: 'absolute',
  height: '24px',
  color: palette.white,
  backgroundColor: palette.black,
  borderRadius: '12px',
  top: '24px',
  right: '16px'
});

export const MeetingHeaderContainer = styled(Stack)({
  flexDirection: 'row',
  alignSelf: 'stretch',
  alignItems: 'start',
  gap: '16px'
});

export const MeetingHeadline = styled(Stack)({
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px'
});

export const MeetingTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: 600
});

export const MeetingDate = styled(Typography)({
  fontSize: '12px',
  fontWeight: 500,
  color: palette.grey[500]
});

export const TabTitle = styled(Typography)({
  fontSize: '14px',
  textTransform: 'none',
  fontWeight: 600,
  lineHeight: '120%'
});

export const MeetingTabsContentContainer = styled(Stack)({
  height: '100%',
  position: 'relative',
  flex: 1
});

export const MeetingContentContainer = styled(Stack)({
  position: 'relative',
  overflow: 'scroll',
  flex: 1,
  paddingTop: '2vh',
  paddingBottom: '1vh'
});

export const MeetingTabsContent = styled(Stack)({
  overflowY: 'auto',
  flex: 1,
  scrollbarWidth: 'thin',
  height: 'calc(100% - 30px)',
  paddingTop: '3vh',
  paddingBottom: '1vh',
  position: 'relative'
});

export const ShareDeleteContainer = styled(Stack)({
  gap: '16px',
  flexDirection: 'row',
  alignItems: 'center'
});

export const ShareButton = styled(IconButton)({
  gap: '4px',
  border: `1px solid ${palette.grey[1200]}`,
  padding: '8px',
  borderRadius: '22px',
  backgroundColor: palette.white,
  color: palette.black,
  fontSize: '13px',
  fontWeight: 500
});

export const DeleteButton = styled(IconButton)({
  gap: '4px',
  padding: '8px',
  borderRadius: '22px',
  color: palette.grey[500],
  fontSize: '13px',
  fontWeight: 500
});

export const Row = styled(CoreRow)({
  gap: '16px'
});

export const StartStack = styled(Stack)({
  alignItems: 'flex-start',
  gap: '2px'
});
